/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';

import { MessageService } from 'primeng/api';
import { UserChangePasswordService } from './users_change_password.service';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { FormBuilder, Validators } from '@angular/forms';
import { TokenService } from 'src/app/auth/services/token/token.service';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import { UserService } from '../gestion/users/user.service';

@Component({
  selector: 'pg-user-change-password',
  templateUrl: './user_change_password.component.html',
  providers: [MessageService]
})
export class UserChangePasswordComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(
    private serviceBase: UserChangePasswordService,
    private fb: FormBuilder,
    private messageService: MessageService,
    private tokenService: TokenService,
    private users: UserService
  ) {
    super('', serviceBase);
  }
  visibleSidebar: any;
  ngOnInit(): void {
    this.visibleSidebar = true;
    this.fg = this.fb.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      password2: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ]
    });
  }
  checkReadyToOpen() {
    return (
      this.fg.value.password.length > 4 &&
      this.fg.value.password == this.fg.value.password2
    );
  }
  async onSubmit() {
    const id = this.tokenService.getIdUser();
    const payload = {
      password: this.fg.value.password
    };
    this.message = { message: 'Actualizando contraseña' };
    this.message = await this.users.update(id, payload);
    this.message = { message: 'Cerrando Sesión' };
    await this.serviceBase.delete(id);
    localStorage.clear();
    location.reload();
  }
}
